<template>
<div class="noData h100pct tableSys noBorder cSub mc" :class="{peN:text}">
	<div class="h100pct">
		<!-- <div v-if="text" class="fs26x mb1x">T_T</div> -->
		<Icon name="noData" class="w14x fLight"/>
		<div class="mt1x">{{text}}</div>
		<slot></slot>
	</div>
</div>
</template>
<script>
import {getLanguageStr} from "@/util/language"

export default {
	name: 'NoResult',
	props: {
		txt: {
			type: String,
			default: getLanguageStr("plant258","暂无数据")
		}
	},
	computed: {
		text() {
			return this.txt
		}
	}
}
</script>
<style lang="scss" scoped>
.noData{padding:1rem;text-align:center;
	>*{vertical-align:middle;}
	svg{max-height:70%;}
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/NoResult.vue